import AboutUsCard from './AboutUsCard';

export default AboutUsCard;
